import { render, staticRenderFns } from "./VerificationPassword.vue?vue&type=template&id=aa63aee4&"
import script from "./VerificationPassword.vue?vue&type=script&lang=js&"
export * from "./VerificationPassword.vue?vue&type=script&lang=js&"
import style0 from "./VerificationPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports